import React from 'react'

export const CheckGreenIcon = (props) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_684_3291)">
        <mask
          id="mask0_684_3291"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="40"
          height="40"
        >
          <path d="M40 0H0V40H40V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_684_3291)">
          <path
            d="M20.0496 1.66661C30.1662 1.69994 38.3829 9.96661 38.3329 20.0833C38.2829 30.1666 30.0329 38.3499 19.9496 38.3333C9.83291 38.2999 1.61624 30.0333 1.66624 19.9166C1.71624 9.83327 9.96624 1.63327 20.0496 1.66661ZM17.1662 23.0333C16.9162 22.8166 16.7162 22.6333 16.5329 22.4666C15.0996 21.1666 13.6829 19.8499 12.2496 18.5666C11.5829 17.9833 10.8329 17.8999 10.1329 18.2833C9.46624 18.6499 9.06624 19.3833 9.28291 20.1666C9.39958 20.6166 9.69958 21.0833 10.0496 21.3999C11.8996 23.1333 13.7829 24.8166 15.6496 26.5166C16.9162 27.6666 17.6996 27.6333 18.8996 26.4333C22.5496 22.7999 26.2162 19.1666 29.8662 15.5333C29.9829 15.4166 30.0996 15.2999 30.2162 15.1833C30.9496 14.3666 30.9496 13.2666 30.2162 12.5499C29.4829 11.8333 28.4496 11.8333 27.6496 12.5499C27.4496 12.7166 27.2662 12.9166 27.0829 13.0999C23.7996 16.3833 20.4996 19.6833 17.1662 23.0166V23.0333Z"
            fill="#26D06D"
          />
          <path
            d="M17.1661 23.0335C20.5161 19.6835 23.7994 16.4001 27.0828 13.1168C27.2661 12.9335 27.4494 12.7335 27.6495 12.5668C28.4494 11.8501 29.4828 11.8501 30.2161 12.5668C30.9494 13.2835 30.9494 14.3835 30.2161 15.2001C30.0994 15.3168 29.9828 15.4335 29.8661 15.5501C26.2161 19.1835 22.5494 22.8168 18.8994 26.4501C17.6828 27.6501 16.8994 27.6835 15.6494 26.5335C13.7828 24.8335 11.8994 23.1501 10.0494 21.4168C9.69945 21.1001 9.39945 20.6335 9.28278 20.1835C9.06612 19.4001 9.46612 18.6668 10.1328 18.3001C10.8328 17.9168 11.5828 17.9835 12.2494 18.5835C13.6828 19.8668 15.0994 21.1835 16.5328 22.4835C16.7161 22.6668 16.9161 22.8335 17.1661 23.0501V23.0335Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_684_3291">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
